import React, { createContext, useContext, useMemo } from 'react';

interface NotificationContextType {
  isEnabled: boolean;
  userId: string | null;
}

const NotificationContext = createContext<NotificationContextType>({
  isEnabled: false,
  userId: null,
});

interface NotificationProviderProps {
  children: React.ReactNode;
  enabled: boolean;
  userId?: string | null;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
  children,
  enabled,
  userId = null,
}) => {
  const value = useMemo(
    () => ({
      isEnabled: enabled,
      userId: userId,
    }),
    [enabled, userId]
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationContext must be used within NotificationProvider');
  }
  return context;
};

